const trays = [
  ['tray-01', '进样品托盘', 'Sharp_Fusion_1_001'],
  ['tray-02', '注射器托盘', 'Sharp_Fusion_1_001_001'],
  ['tray-03', '125ml 溶剂瓶托盘', 'Sharp_Fusion_1_003'],
  ['tray-04', '加粉塑料托盘', 'Sharp_Fusion_1_005'],
  ['tray-05', '反应釜体托盘', 'Sharp_Fusion_1_005_001_001'],
  ['tray-06', '反应釜盖托盘', 'Sharp_Fusion_1_006'],
  ['tray-07', '瓶盖托盘 A', 'Sharp_Fusion_1_007_001'],
  ['tray-08', '瓶盖托盘 B', 'Sharp_Fusion_1_007_001_001'],
  ['tray-09', '小型夹持架', 'Sharp_Fusion_1_008'],
  ['tray-10', '40ml 试剂瓶托盘', 'Sharp_Fusion_1_010_002_001'],
  ['tray-11', '40ml 瓶盖托盘', 'Sharp_Fusion_1_011_001'],
  ['tray-12', '固体加样托盘', 'Sharp_Fusion_1_012'],
  ['tray-13', '过滤头托盘', 'Sharp_Fusion_1_012_001'],
  ['tray-14', '50ml TIP 托盘', 'Sharp_Fusion_1_013_001'],
  ['tray-15', '8ml 试剂瓶托盘', 'Sharp_Fusion_1_013_001_001'],
  ['tray-16', '8ml 瓶盖托盘', 'Sharp_Fusion_1_019_001'],
  ['tray-17', '通用实验托架', 'Sharp_Fusion_1_028'],
  ['tray-18', '移液工具托架', 'Sharp_Fusion_2_002_001'],
  ['tray-19', '小型器件托架', 'Sharp_Fusion_2_003_001'],
  ['tray-20', '模块化底座', 'Sharp_Fusion_3_002'],
].map(([id, label, name]) => ({
  id,
  label,
  category: '实验托架',
  description: `低模化实验托架 · ${name}`,
  names: [name],
}));

export const catalog = [
  {
    id: 'copper-hydroxide-experiment',
    label: '硫酸铜与氢氧化钠反应',
    category: '模拟实验',
    description: '从试剂瓶移取 CuSO₄ 溶液，再通过加粉模块加入 NaOH，观察蓝色絮状沉淀与后续转化。',
    proceduralId: 'chemical-experiment',
    featured: true,
  },
  {
    id: 'snar-experiment',
    label: '芳香亲核取代（SNAr）',
    category: '模拟实验',
    description: '4-氨基苯酚与 4-氯皮考啉在叔丁醇钾/DMPU 中反应，经萃取、洗涤、干燥和柱层析得到黄色芳醚。',
    proceduralId: 'snar-experiment',
    featured: true,
  },
  {
    id: 'full-scene',
    label: '完整实验室',
    category: '主要场景',
    description: '手套箱、机械臂、UPLC 与巡游 JAKA 机器人的完整空间布局。',
    all: true,
    featured: true,
  },
  {
    id: 'uplc',
    label: 'UPLC-MS',
    category: '核心设备',
    description: '带自动开合样品仓与溶剂瓶组的 UPLC-MS 分析设备。',
    externalId: 'uplc',
    featured: true,
  },
  {
    id: 'jaka-mobile-manipulator',
    label: 'JAKA 移动操作机器人',
    category: '核心设备',
    description: '移动平台、升降立柱、视觉头与关节机械臂整机；在完整场景中沿设备通道自主巡游。',
    proceduralId: 'jaka-mobile-manipulator',
    featured: true,
  },
  {
    id: 'glovebox',
    label: '手套箱外壳',
    category: '核心设备',
    description: '实验室主体外壳、观察窗、管路和接口结构。',
    names: ['手套箱'],
    featured: true,
  },
  {
    id: 'robot-arm',
    label: '机械臂',
    category: '核心设备',
    description: '项目 ABB CRB 15000 机械臂总成；按实际六个转轴重建连杆层级并演示带限位的六轴 IK。',
    names: ['机械臂'],
    featured: true,
  },
  {
    id: 'main-shelves',
    label: '主货架',
    category: '核心设备',
    description: '实验设备内部的主存储与转运货架。',
    names: ['Main_Shelves_001'],
  },
  {
    id: 'transfer-shelves',
    label: '转运货架',
    category: '核心设备',
    description: '小型样品与工具的转运货架模块。',
    names: ['Transfer_Shelves'],
  },
  {
    id: 'tool-library',
    label: '工具库',
    category: '核心设备',
    description: '工具库主体模块及内部工具存放结构。',
    names: ['Tool_Library_001_270'],
  },
  {
    id: 'mixing-module',
    label: '混合模块',
    category: '工艺模块',
    description: '用于样品混合与反应处理的模块设备。',
    names: ['Mixing_Module'],
  },
  {
    id: 'powder-module',
    label: '加粉模块',
    category: '工艺模块',
    description: '固体粉料自动加样模块。',
    names: ['Powder_Adding_Module'],
  },
  {
    id: 'openlid-module',
    label: '开盖模块',
    category: '工艺模块',
    description: '试剂瓶与反应容器的自动开盖设备。',
    names: ['Openlid_Module_001'],
  },
  {
    id: 'screw-module',
    label: '螺纹操作模块',
    category: '工艺模块',
    description: '瓶盖与螺纹件自动旋拧模块。',
    names: ['Screw_Module'],
  },
  {
    id: 'transition-cabin',
    label: '过渡舱',
    category: '工艺模块',
    description: '连接外部与内部环境的过渡舱体。',
    names: ['Transition_Cabin'],
  },
  {
    id: 'electrical-cabinet',
    label: '电气柜',
    category: '辅助设备',
    description: '实验系统电气控制柜。',
    names: ['Electrical_Cabinet'],
  },
  {
    id: 'desktop',
    label: '操作台面',
    category: '辅助设备',
    description: '手套箱内部主要操作台面。',
    names: ['Desktop'],
  },
  {
    id: 'camera-detection',
    label: '视觉检测模块',
    category: '辅助设备',
    description: '用于识别与定位的相机检测组件。',
    names: ['Camera_Detection'],
  },
  {
    id: 'garbage-can',
    label: '废弃物容器',
    category: '辅助设备',
    description: '实验废弃物收集容器。',
    names: ['Garbage_Can'],
  },
  {
    id: 'pipette-1ml',
    label: '1ml 移液腔体',
    category: '工具组件',
    description: '1ml 移液工具腔体与夹持结构。',
    names: ['Pipette_1ml_Chamber'],
  },
  {
    id: 'pipette-5ml',
    label: '5ml 移液腔体',
    category: '工具组件',
    description: '5ml 移液工具腔体与夹持结构。',
    names: ['Pipette_5ml_Chamber_001'],
  },
  {
    id: 'tray-clamp',
    label: '托盘夹持头',
    category: '工具组件',
    description: '机械臂使用的托盘夹持末端。',
    names: ['Tray_Clamping_Head'],
  },
  {
    id: 'screwdriver',
    label: '电动螺丝刀头',
    category: '工具组件',
    description: '电动旋拧工具执行头。',
    names: ['electric_screwdriver_head'],
  },
  {
    id: 'bottle-125ml',
    label: '125ml 溶剂瓶',
    category: '实验耗材',
    description: '125ml 溶剂瓶单件代表 · 场景内 2 件。',
    prefix: 'Bottle_125ml_002',
    representative: true,
    count: 2,
  },
  {
    id: 'bottle-8ml',
    label: '8ml 试剂瓶',
    category: '实验耗材',
    description: '8ml 试剂瓶单件代表 · 场景内 12 件。',
    prefix: 'Bottle_8ml',
    representative: true,
    count: 12,
  },
  {
    id: 'reaction-tube',
    label: '1ml 反应管',
    category: '实验耗材',
    description: '1ml 反应管单件代表 · 场景内 4 件。',
    prefix: 'Reactiontube_1mL',
    representative: true,
    count: 4,
  },
  {
    id: 'filter-head',
    label: '0.45μm 过滤头',
    category: '实验耗材',
    description: '过滤头单件代表 · 场景内 4 件。',
    prefix: 'Filter0_45_Head_',
    representative: true,
    count: 4,
  },
  {
    id: 'tip-1ml',
    label: '1ml TIP 头架',
    category: '实验耗材',
    description: '1ml TIP 头实验托架。',
    names: ['TIP_Head_1ml'],
  },
  {
    id: 'tip-50ul',
    label: '50μl TIP 头',
    category: '实验耗材',
    description: '50μl TIP 头单件代表 · 场景内 8 件。',
    prefix: 'TIP_Head_50ul',
    representative: true,
    count: 8,
  },
  {
    id: 'tip-5ml',
    label: '5ml TIP 头',
    category: '实验耗材',
    description: '5ml TIP 头单件代表 · 场景内 4 件。',
    prefix: 'TIP_Head_5ml',
    representative: true,
    count: 4,
  },
  {
    id: 'step-cylinder-014',
    label: 'STEP 圆柱组件 A',
    category: '实验耗材',
    description: '圆柱状实验部件单件代表 · 场景内 6 件。',
    prefix: 'STEP_Cylinder_014',
    representative: true,
    count: 6,
  },
  {
    id: 'step-cylinder-020',
    label: 'STEP 圆柱组件 B',
    category: '实验耗材',
    description: '圆柱状实验部件单件代表 · 场景内 8 件。',
    prefix: 'STEP_Cylinder_020',
    representative: true,
    count: 8,
  },
  {
    id: 'step-flatpatch',
    label: 'STEP 平面组件',
    category: '实验耗材',
    description: '薄型平面实验组件。',
    names: ['STEP_FlatPatch_051'],
  },
  ...trays,
];

export const categories = [...new Set(catalog.map((entry) => entry.category))];
